var render, staticRenderFns
import script from "./InputContents.vue?vue&type=script&lang=js&"
export * from "./InputContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd02906",
  null
  
)

export default component.exports